module.exports = __webpack_public_path__ + "495a668e421306e2c27cd1d30fdfb638.png";